namespace app.tarefas.minhasTarefas {

    import IDialogService = ng.material.IDialogService;
    
    export class RemoveTagsController {
        
        public selectedTags: string[] = [];
        
        /** @ngInject **/
        constructor(private $mdDialog: IDialogService,
                public tags: ITaskTag[]) {
        }

        public removeTags(): void {
            this.$mdDialog.hide(this.selectedTags);
        }
        
        public closeDialog(): void {
            this.$mdDialog.cancel();
        }
        
    }
    
    angular
        .module("app.tarefas.minhas-tarefas")
        .controller("app.tarefas.minhas-tarefas.RemoveTagsController", RemoveTagsController);
}